import { call, put } from '@redux-saga/core/effects';
import { AnyAction } from '@reduxjs/toolkit';
import { displayError } from 'app/components/ToasterBar/helpers';
import fetchClient from 'utils/requestInterceptor';
import logger from '../logger';

type ActionWithData<T> = (data: T) => AnyAction;
type ActionWithoutData = () => AnyAction;

export type handleGeneralGETFnType<T> = (
  successCallback: ActionWithData<T>,
  failureCallback: ActionWithoutData,
  url: string,
) => void;
export function* handleGeneralGET<T>(
  successCallback: ActionWithData<T>,
  failureCallback: ActionWithoutData,
  url: string,
) {
  try {
    const { data }: { data: T } = yield call(fetchClient.get, url);
    yield put(successCallback(data));
  } catch (err) {
    yield call(displayError, err);
    yield put(failureCallback());
  }
}
//TODO: Create a general saga for each HTTP Method

//TODO: Uncomment when needed
// export type handleGeneralPOSTFnType<T, S> = (
//   successCallback: (data: T) => AnyAction,
//   failureCallback: () => AnyAction,
//   url: string,
//   requestPayload: S,
// ) => void;
// export function* handleGeneralPOST<T, S>(
//   successCallback: (data: T) => AnyAction,
//   failureCallback: () => AnyAction,
//   url: string,
//   requestPayload: S,
// ) {
//   try {
//     const { data }: { data: T } = yield call(
//       fetchClient.post,
//       url,
//       requestPayload,
//     );
//     yield put(successCallback(data));
//   } catch (err) {
//     console.log(err);
//     yield put(failureCallback());
//   }
// }
export function downloadJsonFileWithUrl(url: string, fileName: string) {
  fetch(url)
    .then(result => {
      result
        .json()
        .then(json => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(
            new Blob([JSON.stringify(json)], { type: 'application/json' }),
          );
          a.download = fileName;
          a.click();
          a.remove();
        })
        .catch(err => logger.error({ message: err as string | Error }));
    })
    .catch(err => logger.error({ message: err as string | Error }));
}
